import { createSelector } from 'reselect'

export const selectAssets = (store) => store.assets

export const selectAllAssets = createSelector([selectAssets], (assets) => assets)
export const selectAssetsError = createSelector([selectAssets], (assets) => assets?.error)
